import { action, observable, makeObservable } from 'mobx';
import { Model, IModelAttributes, attribute, entity } from 'Models/Model';
import * as Models from 'Models/Entities';

export interface ITowOnDetailEntityAttributes extends IModelAttributes {

	tickets: Array<Models.TicketEntity | Models.ITicketEntityAttributes>;
	towOnId: string;
	towOn: Models.TowOnEntity | Models.ITowOnEntityAttributes;
}
@entity('TowOnDetailEntity', 'Tow On Detail')
export default class TowOnDetailEntity extends Model implements ITowOnDetailEntityAttributes {
	/**
	 * Fields to exclude from the JSON serialization in create operations.
	 */
	public static excludeFromCreate: string[] = [];

	/**
	 * Fields to exclude from the JSON serialization in update operations.
	 */
	public static excludeFromUpdate: string[] = [];

	@observable
	@attribute({ isReference: true, manyReference: true })
	public tickets: Models.TicketEntity[] = [];

	@observable
	@attribute()
	public towOnId: string;

	@observable
	@attribute({ isReference: true, manyReference: false })
	public towOn: Models.TowOnEntity;

	constructor(attributes?: Partial<ITowOnDetailEntityAttributes>) {
		super(attributes);

		this.tickets = [];

		makeObservable(this);

		this.assignAttributes(attributes);
	}

	/**
	 * Assigns fields from a passed in JSON object to the fields in this model.
	 * Any reference objects that are passed in are converted to models if they are not already.
	 * This function is called from the constructor to assign the initial fields.
	 */
	public assignAttributes(attributes?: Partial<ITowOnDetailEntityAttributes>) {
		super.assignAttributes(attributes);

		if (attributes) {
			if (attributes.tickets !== undefined && Array.isArray(attributes.tickets)) {
				if (!this.tickets) {
					this.tickets = [];
				}
				for (const model of attributes.tickets) {
					if (model instanceof Models.TicketEntity) {
						this.tickets.push(model);
					} else {
						this.tickets.push(new Models.TicketEntity(model));
					}
				}
			}
			if (attributes.towOnId !== undefined) {
				this.towOnId = attributes.towOnId;
			}
			if (attributes.towOn !== undefined) {
				if (attributes.towOn === null) {
					this.towOn = attributes.towOn;
				} else if (attributes.towOn instanceof Models.TowOnEntity) {
					this.towOn = attributes.towOn;
					this.towOnId = attributes.towOn.id;
				} else {
					this.towOn = new Models.TowOnEntity(attributes.towOn);
					this.towOnId = this.towOn.id;
				}
			}
		}
	}
}
